export default {
  INVESTOR_GOAL_RISK_TOLERANCE_REPOSITORY: Symbol.for('INVESTOR_GOAL_RISK_TOLERANCE_REPOSITORY'),
  INVESTOR_GOAL_RISK_TOLERANCE_STATE_MANAGER: Symbol.for('INVESTOR_GOAL_RISK_TOLERANCE_STATE_MANAGER'),
  INVESTOR_GOAL_RISK_TOLERANCE_DTO_SERVICE: Symbol.for('INVESTOR_GOAL_RISK_TOLERANCE_DTO_SERVICE'),
  INVESTOR_GOAL_RISK_TOLERANCE_ANSWERS_SERVICE: Symbol.for('INVESTOR_GOAL_RISK_TOLERANCE_ANSWERS_SERVICE'),
  INVESTOR_GOAL_RISK_TOLERANCE_CHOSE_WARNING_ANSWERS_SERVICE: Symbol.for('INVESTOR_GOAL_RISK_TOLERANCE_CHOSE_WARNING_ANSWERS_SERVICE'),
  UPDATE_INVESTOR_GOAL_RISK_TOLERANCE_COMMAND: Symbol.for('UPDATE_INVESTOR_GOAL_RISK_TOLERANCE_COMMAND'),
  NOTIFY_INVESTOR_GOAL_RISK_TOLERANCE_COMMAND: Symbol.for('NOTIFY_INVESTOR_GOAL_RISK_TOLERANCE_COMMAND'),
};
